import styled from 'styled-components'

const DashboardTitle = styled.div`
  flex: 1;
  min-width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const DashboardTitleText = styled.h1`
  color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
`

type Props = {
  children?: React.ReactNode
}

const DashboardHeaderSubTitle: React.FC<Props> = ({ children, ...rest }) => (
  <DashboardTitle {...rest}>
    <DashboardTitleText id="header-subtitle">{children}</DashboardTitleText>
  </DashboardTitle>
)

export default DashboardHeaderSubTitle
